module.exports = __webpack_public_path__ + "static/media/fleche-droite-cercle.48acc76d.png";